import { MouseEvent, ChangeEvent } from 'react';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import { visuallyHidden } from '@mui/utils';
import { HeadCell, Order } from '../../../../model/table';
import { AppList } from '../../../../model/list';

type Props = {
	headCells: readonly HeadCell<AppList>[];
	listType?: 'checkbox' | 'radio';
	numSelected?: number;
	onRequestSort: (event: MouseEvent<unknown>, property: keyof AppList) => void;
	onSelectAllClick?: (event: ChangeEvent<HTMLInputElement>) => void;
	order: Order;
	orderBy: number | string;
	rowCount: number;
};

export default function TableAppHeader({
	listType,
	onSelectAllClick,
	order,
	orderBy,
	numSelected = 0,
	rowCount,
	onRequestSort,
	headCells,
}: Props) {
	// const createSortHandler = (property: keyof AppList) => (e: MouseEvent<unknown>) => {
	// 	onRequestSort(e, property);
	// };

	return (
		<TableHead>
			<TableRow>
				{listType === 'checkbox' && (
					<TableCell padding='checkbox'>
						<Checkbox
							color='primary'
							indeterminate={numSelected > 0 && numSelected < rowCount}
							checked={rowCount > 0 && numSelected === rowCount}
							onChange={onSelectAllClick}
							inputProps={{
								'aria-label': 'select all',
							}}
						/>
					</TableCell>
				)}
				{headCells.map(headCell => (
					<TableCell
						key={headCell?.id}
						align={headCell?.align || 'left'}
						padding={headCell?.disablePadding ? 'none' : 'normal'}
						sortDirection={orderBy === headCell?.id ? order : false}
						classes={{ head: `${headCell.width || ''}` }}
					>
						<TableSortLabel
							active={headCell.sort}
							// direction={orderBy === headCell?.id ? order : 'asc'}
							// onClick={createSortHandler(headCell?.id)}
							hideSortIcon={!headCell.sort}
							sx={{
								cursor: headCell.sort ? 'pointer' : 'default', // 조건부로 커서 스타일 적용
								'&:hover': {
									color: headCell.sort ? 'inherit' : 'currentcolor', // hover 시 색상 변경 방지
								},
								'&.Mui-active': {
									color: 'inherit', // 정렬 활성화 시 색상 변경 방지
								},
							}}
						>
							{headCell?.label}
							{orderBy === headCell?.id ? (
								<Box component='span' sx={visuallyHidden}>
									{order === 'desc' ? 'sorted descending' : 'sorted ascending'}
								</Box>
							) : null}
						</TableSortLabel>
					</TableCell>
				))}
			</TableRow>
		</TableHead>
	);
}
